module.exports = __webpack_public_path__ + "img/rewards_banner.cf41ef15.png";